import { render, staticRenderFns } from "./inputmodal.vue?vue&type=template&id=1c29996f&"
import script from "./inputmodal.vue?vue&type=script&lang=js&"
export * from "./inputmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports